import { withState } from 'recompose';

export default withState('loadingModal', 'updateLoadingModal', false);
